<template>
  <el-dialog
    :title="isEdit ? '编辑字典类型' : '新增字典类型'"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="字典名称" prop="dictName">
        <el-input v-model="form.dictName" placeholder="请输入字典名称，如：工具类型" maxlength="100" show-word-limit />
      </el-form-item>
      <el-form-item label="字典类型标识" prop="dictType">
        <el-input
          v-model="form.dictType"
          placeholder="请输入唯一标识，如：tool_type"
          maxlength="100"
          :disabled="isEdit"
        />
        <div v-if="isEdit" class="field-tip">
          字典类型标识为业务契约键，创建后不可修改
        </div>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio label="0">正常</el-radio>
          <el-radio label="1">停用</el-radio>
        </el-radio-group>
        <div v-if="form.status === '1'" class="field-tip">
          停用后，该字典类型下数据将不参与业务选项。不允许删除类型，请用停用代替。
        </div>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="备注说明" maxlength="500" />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button :disabled="saving" @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="saving" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 服务
import { dictService } from './dict.service';
import { clearDictCache } from '@/features/components/dict/dict.api';

export default {
  name: 'DictTypeDialog',

  data() {
    return {
      visible: false,
      saving: false,
      isEdit: false,
      form: {
        dictId: null,
        dictName: '',
        dictType: '',
        status: '0',
        remark: ''
      },
      rules: {
        dictName: [{ required: true, message: '请输入字典名称', trigger: 'blur' }],
        dictType: [
          { required: true, message: '请输入字典类型标识', trigger: 'blur' },
          { pattern: /^[a-z][a-z0-9_]*$/, message: '只允许小写字母、数字和下划线，且以字母开头', trigger: 'blur' }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    };
  },

  methods: {
    open(row) {
      this.isEdit = !!row;
      if (row) {
        this.form = {
          dictId: row.dictId,
          dictName: row.dictName,
          dictType: row.dictType,
          status: row.status || '0',
          remark: row.remark || ''
        };
      } else {
        this.form = { dictId: null, dictName: '', dictType: '', status: '0', remark: '' };
      }
      this.visible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        const req = this.isEdit 
          ? dictService.updateType(this.form) 
          : dictService.saveType(this.form);
        
        req.then(() => {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
          clearDictCache();
          this.visible = false;
          this.$emit('saved');
        }).finally(() => {
          this.saving = false;
        });
      });
    },

    handleClose() {
      this.$refs.form && this.$refs.form.resetFields();
    }
  }
};
</script>

<style scoped>
.field-tip {
  font-size: 12px;
  line-height: 1.5;
  color: #e6a23c;
  margin-top: 4px;
}
</style>
